'use string'

import {findSelectionAndCrmData, userPrevent} from "../../functions";
import {CardTypes} from "../../common";
import {renderUpdateValuesOnDemand} from "../../app";
import {openOptionsCard, setWidthOfCardDependingOnMenu} from "./optionsCards";
import {Button} from "../interfaces/buttons/Button";
import {showAsideContainer} from "../menu/menu";
import {BaseElement} from "../interfaces/BaseElement";
import { Vantages } from '../components/vantage/Vantage';
import {UIRoot} from "../../settings";
import {isDesktop} from "../../settings";
import {UnitCardClass} from "./unitCards/UnitCardClass";

export const createCompareBlock = () => {
    if (userPrevent()) return;

    const menu = document.querySelector('.aside__container');
    const menuWidth = menu ? menu.getAttribute('data-initial-width') : 0;

    const compareBlockWidth = `${window.innerWidth - menuWidth}px`;
    const block = new BaseElement()
        .addClass('compare-block', 'non-canvas')
        .appendTo(UIRoot)
        .addStyle('width', compareBlockWidth)
        .DOMElement;

    setTimeout(() => renderUpdateValuesOnDemand(true), 1000);
    setWidthOfCardDependingOnMenu(block);

    createCompareCards(block);
    compareData(block, 'bold');
}

const createCompareCards = (parent) => {
    const cardsList = document.querySelectorAll(`.${CardTypes.Unit}-card`);
    cardsList.forEach(card => {
        const engineId = card.getAttribute('data-engineid');
        const {crmDataOfFlat} = findSelectionAndCrmData(engineId);

        new BaseElement()
            .addClass('compare-block__card', 'compare-card')
            .addAttribute('data-engine', 'engineId')
            .appendTo(parent);

        openOptionsCard( {object: crmDataOfFlat, isForCompare: true});
    })

    createCloseButton(parent);
}

const createCloseButton = (parent) => {
    new Button()
        .addClass('compare-block__close-button', 'close-button-cross')
        .event('click', closeHandler)
        .appendTo(parent);
}

function closeHandler() {
    if (Vantages.isActive()) {
        Vantages.close(() => {
            document.querySelector('.compare-block').remove();

            if (isDesktop)
                showAsideContainer();

            UnitCardClass.cards.forEach(card => card.html.classList.remove('hidden'));
        });
    } else {
        document.querySelector('.compare-block').remove();

        if (isDesktop)
            showAsideContainer();

        UnitCardClass.cards.forEach(card => card.html.classList.remove('hidden'));
    }
}

const compareData = (compareBlock, mode) => {
    const cardsInfoPoints = compareBlock.getElementsByClassName('card__info-points');
    const cardsPrice = compareBlock.getElementsByClassName('options-card__price-value');

    switch (mode) {
        case 'bold':
            boldCompareMode(cardsInfoPoints);
            break;
        case 'color':
            colorCompareMode(cardsInfoPoints, cardsPrice);
            break;
        default:
            console.log('compareData: default case');
            break;
    }
}

const boldCompareMode = (infoPoints) => {
    const leftCardDifferenceData = {exposure: []};
    const rightCardDifferenceData = {exposure: []};
    fillCardsDifferenceData({leftCardDifferenceData, rightCardDifferenceData, infoPoints});

    if (Object.keys(leftCardDifferenceData).length > 1 || (Object.keys(leftCardDifferenceData).length === 1 && leftCardDifferenceData.exposure.length > 0)) //{
        addDifferenceDataToCard(leftCardDifferenceData, infoPoints[0], 'bold');

    if (Object.keys(rightCardDifferenceData).length > 1 || (Object.keys(rightCardDifferenceData).length === 1 && rightCardDifferenceData.exposure.length > 0)) //{
        addDifferenceDataToCard(rightCardDifferenceData, infoPoints[1], 'bold');
}

const fillCardsDifferenceData = (vars) => {
    const { infoPoints, leftCardDifferenceData, rightCardDifferenceData } = vars;
    const leftCardInfoPoints = getInfoPointsStructuredData(infoPoints[0]);
    const rightCardInfoPoints = getInfoPointsStructuredData(infoPoints[1]);
    const commonFields = getCommonFields(leftCardInfoPoints, rightCardInfoPoints);
    for (let element of commonFields) {
        if (element === 'exposure') {
            for (let i = 0; i < leftCardInfoPoints.exposure.length; i++) {
                if (!rightCardInfoPoints.exposure.includes(leftCardInfoPoints.exposure[i]))
                    leftCardDifferenceData.exposure.push(leftCardInfoPoints.exposure[i]);
            }
            for (let i = 0; i < rightCardInfoPoints.exposure.length; i++) {
                if (!leftCardInfoPoints.exposure.includes(rightCardInfoPoints.exposure[i]))
                    rightCardDifferenceData.exposure.push(rightCardInfoPoints.exposure[i]);
            }
            continue;
        }

        if (parseFloat(leftCardInfoPoints[element]) === parseFloat(rightCardInfoPoints[element]))
            continue;

        (parseFloat(leftCardInfoPoints[element]) > parseFloat(rightCardInfoPoints[element])) ?
          leftCardDifferenceData[element] = leftCardInfoPoints[element]:
          rightCardDifferenceData[element] = rightCardInfoPoints[element];
    }
}

const getCommonFields = (leftCardInfoPoints, rightCardInfoPoints) => {
    const commonFields = [];
    for (let key in leftCardInfoPoints) {
        if (rightCardInfoPoints.hasOwnProperty(key))
            commonFields.push(key);
    }

    return commonFields;
}

const colorCompareMode = (infoPoints, prices) => {
    const leftCardData = getInfoPointsStructuredData(infoPoints[0]);
    const rightCardData = getInfoPointsStructuredData(infoPoints[1]);
    const priceDifferenceInPercents = getPriceDifferenceInPercents(prices);
    const differenceData = {};

    for (let key in rightCardData) {
        if (key === 'exposure') {
            differenceData[key] = [];
            for (let i = 0; i < rightCardData[key].length; i++) {
                if (!leftCardData[key].includes(rightCardData[key][i]))
                    differenceData[key].push(rightCardData[key][i])
            }
            continue;
        }
        let leftValue = parseInt(leftCardData[key]);
        let rightValue = parseInt(rightCardData[key]);
        if (isNaN(leftValue))
            leftValue = 0;

        const value = rightValue - leftValue;
        if (value === 0)
            continue;

        differenceData[key] = value;
    }

    addDifferenceDataToCard(differenceData, infoPoints[1], 'color');
    priceDifferenceInPercents && addDifferencePriceDataToCard(priceDifferenceInPercents, prices[1]);
}

const getInfoPointsStructuredData = (infoPoints) => {
    const result = {};
        for (let i = 0; i < infoPoints.children.length; i++) {
        let value = '';
        let title = '';
        title = infoPoints.children[i].querySelector('.card__info-points-block_subtitle').children[0].getAttribute('data-dictionary');
        if (title === 'apt. type') continue;
        if (title === 'exposure') {
            value = [];
            const exposures = infoPoints.children[i].getElementsByClassName('card__info-points-block_data_text');
            for (let k = 0; k < exposures.length; k++) {
                value.push(exposures[k].getAttribute('data-dictionary'));
            }
        } else {
            value = infoPoints.children[i].querySelector('.card__info-points-block_data_text').getAttribute('data-dictionary');
        }
        result[title] = value;
    }
    return result;
};

const getPriceDifferenceInPercents = (prices) => {
    if (prices.length <= 1)
        return 0;

    const leftCardPrice = parseFloat(prices[0].innerHTML.replace(/,/g, ''));
    const rightCardPrice = parseFloat(prices[1].innerHTML.replace(/,/g, ''));
    let differenceInPercents;
    if (rightCardPrice > leftCardPrice) {
        differenceInPercents = Math.round(rightCardPrice / leftCardPrice * 100 - 100);
    } else if (rightCardPrice < leftCardPrice) {
        differenceInPercents = Math.round(leftCardPrice / rightCardPrice * -100 + 100);
    }
    let sign;
    (differenceInPercents < 0) ? sign = '' : sign = '+';

    return `${sign}${differenceInPercents}`;
};

const addDifferenceDataToCard = (differenceData, card, mode) => {
    for (let key in differenceData) {
        if (key === 'exposure') {
            for (let i = 0; i < differenceData[key].length; i++) {
                const exposureElement = card.querySelector(`[data-dictionary="${differenceData[key][i]}"]`);
                if (exposureElement)
                    exposureElement.classList.add(`positive-difference--${mode}`);
            }
            continue;
        }

        const targetField = card
          .querySelector(`[data-dictionary="${key}"]`)
          .closest('.card__info-points-block-wrapper')
          .querySelector('.card__info-points-block_data-wrapper');

        if (mode === 'color') {
            let color = '';
            differenceData[key] > 0 ?
              color = 'positive':
              color = 'negative';
            const differenceField = document.createElement('span');
            const sign = differenceData[key] > 0 ? '+' : '';
            differenceField.innerHTML = `(${sign}${differenceData[key]})`;
            differenceField.classList.add(
              'options-card__info-points-block_data_text',
              'card__info-points-block_data_text',
              `${color}-difference--color`
            );
            targetField.appendChild(differenceField);
        } else if (mode === 'bold') {
            targetField.classList.add('positive-difference--bold');
        }
    }
}

const addDifferencePriceDataToCard = (differenceData, priceField) => {
    const priceParentElement = priceField.parentElement;
    const priceDifferenceInPercentsElement = document.createElement('span');
    priceDifferenceInPercentsElement.innerHTML = `(${differenceData}%)`;
    if (differenceData > 0) {
        priceDifferenceInPercentsElement.classList.add('negative-difference');
    } else if (differenceData < 0) {
        priceDifferenceInPercentsElement.classList.add('positive-difference');
    }
    priceParentElement.appendChild(priceDifferenceInPercentsElement);
};
